(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ma-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){if(event.target.matches('[data-ma-sort]'))event.target.form.requestSubmit();});
document.addEventListener('click',function(event){document.querySelectorAll('.ma-filter-menu[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',function(event){if(event.key==='Escape')document.querySelectorAll('.ma-filter-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ma-search"] && !Shopify.designMode) return;
  try {
    function normalizeModel(value) {
  return value.trim().replace(/\b(MSA|MS|FSA|FS|HSA|HS|HLA|HL|HTA|HT|BGA|BG|RMA|RM|KMA|KM|LC|TC|TS|SE|RE)(\d)/gi, '$1 $2').replace(/\b(\d{3})\s*(XP)\b/gi, '$1 $2');
}
function setupMaSearch(root) {
  root.querySelectorAll('[data-ma-search]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const input = form.querySelector('[name=q]');
    const box = form.querySelector('.ma-suggestions');
    let timer, request, version = 0;
    const hide = () => { box.hidden = true; input.setAttribute('aria-expanded','false'); };
    form.addEventListener('submit', () => {input.value = normalizeModel(input.value);});
    input.addEventListener('input', () => {
      clearTimeout(timer); if (request) request.abort(); const current = ++version;
      const query = normalizeModel(input.value); hide();
      if (query.length < 2) return;
      timer = setTimeout(async () => {
        request = new AbortController();
        try {
          const params = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'5','resources[options][unavailable_products]':'last'});
          const response = await fetch(form.action.replace(/\/search\/?$/, '/search/suggest.json')+'?'+params,{signal:request.signal});
          if (!response.ok) return;
          const data = await response.json();
          if (current !== version || !form.contains(document.activeElement)) return;
          const products = data.resources?.results?.products || [];
          box.replaceChildren();
          products.forEach(product => {
            const link = document.createElement('a'); link.href = product.url;
            if(product.image) {const img = document.createElement('img');img.src=product.image;img.alt='';img.width=48;img.height=48;link.append(img);}
            const title = document.createElement('span');title.textContent=product.title;link.append(title);box.append(link);
          });
          const all = document.createElement('a'); all.className='ma-search-all'; const resultsParams = new URLSearchParams({q:query,type:'product','options[prefix]':'last'}); all.href=form.action+'?'+resultsParams; all.textContent=form.dataset.resultsLabel; box.append(all); box.hidden=false; input.setAttribute('aria-expanded','true');
        } catch(error) { if(error.name !== 'AbortError') hide(); }
      },220);
    });
    form.addEventListener('keydown', event => {
      if(event.key==='Escape') {event.preventDefault();hide();input.focus();return;}
      if(box.hidden || !['ArrowDown','ArrowUp'].includes(event.key)) return;
      const links=Array.from(box.querySelectorAll('a')); if(!links.length)return;
      event.preventDefault();const current=links.indexOf(document.activeElement);
      const next=event.key==='ArrowDown'?(current+1)%links.length:(current<0?links.length-1:(current-1+links.length)%links.length);
      links[next].focus();
    });
    form.addEventListener('focusout',()=>{setTimeout(()=>{if(!form.contains(document.activeElement))hide();},0);});
    document.addEventListener('click', event=>{if(!form.contains(event.target)) hide();});
  });
}
document.addEventListener('DOMContentLoaded',()=>setupMaSearch(document));
document.addEventListener('shopify:section:load',event=>setupMaSearch(event.target));
  } catch(e) { console.error(e); }
})();

})();
